import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {NavLink} from "react-router-dom";
import ScrollContainer from 'react-indiana-drag-scroll';
import './SubNav.scss';
import {isInternalLink} from "../../helpers/filters";

class SubNavQuery extends Query<Data, {name: String}> {}

const GET_MENU = gql`
    query menuByName($name: String!) {
        menuByName(name: $name) {
            ... on Menu {
                links {
                    ... on MenuLink {
                        label
                        url {
                            routed
                            path
                        }
                    }
                }
            }
        }
    },
`;

const shouldBeExactMatch = path => {
    const allowSubPageMatches = [
        '/careers/stories'
    ];

    return !allowSubPageMatches.includes(path);
};

const SubNav = ({name}) => (
    <SubNavQuery asyncMode query={GET_MENU} variables={{ name }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) return null;

            const menu = data.menuByName;

            if (!(menu.links && menu.links.length > 0)) return null;
            window.dispatchEvent(new Event('resize'));

            return (
                <div id="site-sub-navigation" className="site-header__site-subNav">
                    <div className="container">
                        <ScrollContainer 
                            className="subNav"
                            component="ul">
                            {menu.links.map((link, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <li key={`${index}_${link.label}`} className="subNav__item" id={`subnav-item-${index}`}>

                                    {(isInternalLink(link.url.path)) ?
                                        <NavLink to={link.url.path} activeClassName="active"
                                                 exact={shouldBeExactMatch(link.url.path)}>
                                            {link.label}
                                        </NavLink>
                                        :
                                        <NavLink to={link.url.path} activeClassName="active" target="_blank"
                                                 exact={shouldBeExactMatch(link.url.path)}>
                                            {link.label}
                                        </NavLink>
                                    }
                                </li>
                            ))}
                        </ScrollContainer>
                    </div>
                </div>
            );
        }}
    </SubNavQuery>


);

SubNav.propTypes = {
   name: PropTypes.string.isRequired
};

export default SubNav;



// WEBPACK FOOTER //
// ./frontend/components/Header/SubNav.jsx